import { render, staticRenderFns } from "./goodsTothirdParty.vue?vue&type=template&id=2cfaf26a&scoped=true&"
import script from "./goodsTothirdParty.vue?vue&type=script&lang=js&"
export * from "./goodsTothirdParty.vue?vue&type=script&lang=js&"
import style0 from "./goodsTothirdParty.vue?vue&type=style&index=0&id=2cfaf26a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfaf26a",
  null
  
)

export default component.exports